import { useEffect, useState } from "react";
import { IUseImageLoaderProps } from "../ExlyImageWLoadingUXV1/ExlyImageWLoadingUXV1.interfaces";
import { getOptimisedImageUrl } from "../../utils/getOptimisedImageUrl";
import { getOptimisedLowQualityImageUrl } from "../../utils/getOptimisedLowQualityImageUrl";
import { isImageFromOptimizingCdn } from "../../utils/isImageFromOptimizingCdn";

/**
 * @deprecated - as it loads optimised image of required width eagerly and 10 px (blur) width image lazily
 */
export const useImageLoader = ({
  imageUrl,
  fetchWidth,
  cdnBaseUrl,
}: IUseImageLoaderProps) => {
  const [dynamicImageUrl, setDynamicImageUrl] = useState(
    isImageFromOptimizingCdn(imageUrl, cdnBaseUrl)
      ? getOptimisedLowQualityImageUrl({ imageUrl, cdnBaseUrl })
      : imageUrl,
  );

  useEffect(() => {
    if (isImageFromOptimizingCdn(imageUrl, cdnBaseUrl)) {
      setDynamicImageUrl(
        getOptimisedLowQualityImageUrl({ imageUrl, cdnBaseUrl }),
      );
      const highQualityImage = new Image();
      const highQualityImageUrl = getOptimisedImageUrl({
        imageUrl,
        fetchWidth,
        cdnBaseUrl,
      });
      highQualityImage.src = highQualityImageUrl;
      highQualityImage.onload = () => setDynamicImageUrl(highQualityImageUrl);
    } else setDynamicImageUrl(imageUrl);
  }, [imageUrl]);

  return { dynamicImageUrl };
};
